import type CampaignStatus from '@/Enums/CampaignManagement/CampaignStatus.enum';
import type ItemStatus from '@/Enums/ItemStatus.enum';
import StatusChip from '@/components/StatusChip';
import { itemStatusChipPropMap } from '@/constants/itemStatus/chipProps';
import { memo } from 'react';

interface IProps {
  status?: ItemStatus | CampaignStatus;
}

const LineItemStatus = memo(({ status }: IProps) => {
  if (!status) return null;
  return <StatusChip {...itemStatusChipPropMap[status]} />;
});

export default LineItemStatus;
